import { render, staticRenderFns } from "./EditableTableItemInput.vue?vue&type=template&id=4399b20b&scoped=true"
import script from "./EditableTableItemInput.vue?vue&type=script&lang=js"
export * from "./EditableTableItemInput.vue?vue&type=script&lang=js"
import style0 from "./EditableTableItemInput.vue?vue&type=style&index=0&id=4399b20b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4399b20b",
  null
  
)

export default component.exports